import * as React from "react";

// Styles
import "./index.scss";

const Container = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default Container;
